import { render } from "./GameLoader.vue?vue&type=template&id=fb252b56"
import script from "./GameLoader.vue?vue&type=script&lang=js"
export * from "./GameLoader.vue?vue&type=script&lang=js"

import "./GameLoader.vue?vue&type=style&index=0&id=fb252b56&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/GameLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb252b56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb252b56', __exports__)) {
    api.reload('fb252b56', __exports__)
  }
  
  module.hot.accept("./GameLoader.vue?vue&type=template&id=fb252b56", () => {
    api.rerender('fb252b56', render)
  })

}


export default __exports__